export class InItHandleModal {
    static readonly type = '[boolean] InItHandleModal';
    constructor() { }
}
export class OpenHandler {
    static readonly type = '[boolean] OpenHandler';
    constructor() { }
}

export class CancelHandler {
    static readonly type = '[boolean] CloseHandler';
    constructor() { }
}
